import React from "react";

import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";

import { clsx } from "clsx";

export const ImageWrapper = withFocusRing((props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "relative",
      props.fullWidth ? "w-full-vw" : "w-full",
      props.onClick && "cursor-pointer",
    )}
  />
));

export const ImageRatio = withFocusRing((props: any) => (
  <div
    {...props}
    style={{
      paddingBottom: `${(props.ratio.split("/")[1] / props.ratio.split("/")[0]) * 100}%}`,
    }}
  />
));

export const StyledImage = withFocusRing((props: any) => (
  <img
    {...props}
    className={clsx(
      props.className,
      props.cover &&
        "inset-0 absolute h-full w-full object-cover object-center",
      props.hover &&
        "transition-layout pointer-events-none opacity-0 md:group-hover:pointer-events-auto md:group-hover:opacity-100",
    )}
  />
));

export const ClickableImageWrapper = withFocusRing((props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "h-full",
      props.onClick && "cursor-pointer",
    )}
  />
));
